import { LinkConfig } from '@sail/ui';
import { helmTokens } from '../tokens';
export const linkCustomization = LinkConfig.customize({
    css: {
        fontSize: 'inherit',
        fontWeight: 'semibold',
        lineHeight: 'inherit',
        textColor: 'action.primary',
        ':hover': {
            textColor: 'action.primary.hovered'
        },
        transition: `all ${helmTokens.transition.hover}`
    }
});

//# sourceMappingURL=link.js.map